import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import SimpleBar from "simplebar-react"

const ModalErrors = ({ details, showModal, setShowModal, onClose }) => {
  return (
    <Modal
      isOpen={showModal}
      toggle={() => {
        setShowModal(!showModal)
      }}
      size="lg"
      centered
      onClose={() => {
        onClose()
      }}
    >
      <ModalHeader>
        Mensagem de Erro
        <button
          type="button"
          onClick={() => {
            setShowModal(false)
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>{details}</ModalBody>
    </Modal>
  )
}

ModalErrors.propTypes = {
  details: PropTypes.string,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  onClose: PropTypes.func,
}

export default ModalErrors
